import { AssessmentStepKeys } from '@/enums'
import { makeBusinessTypeSubmitValue } from '../../helpers'
import { ConditionalOfferAssessment } from './BasePage'

interface StepProps {
  [key: string]: {
    categoryId?: string
    helperText?: string
  }
}

interface Messages {
  helperText: string
}

interface SubmitValues {
  approxRevenue: any
  businessType: any
  companyFoundedDateLead: any
  [key: string]: any
}

const cyberAssessmentSteps = [
  AssessmentStepKeys.businessTypeAi,
  AssessmentStepKeys.businessTypeConfirmationAi,
  AssessmentStepKeys.businessTypeMainSelectionAi,
  AssessmentStepKeys.companyFoundedDateLead,
  AssessmentStepKeys.employeesCount,
  AssessmentStepKeys.approxRevenue,
]

const categoryId = 'CY'

const makeSubmitValues = () => {
  return function transform<T>(values: T): T {
    const typedValues = values as SubmitValues
    return {
      ...values,
      lastYearFinances: typedValues.approxRevenue,
      businessType: makeBusinessTypeSubmitValue(typedValues.businessType),
      companyFoundedDate: typedValues.companyFoundedDateLead,
    } as T
  }
}

const makeStepProps = (messages: Messages): StepProps => ({
  [AssessmentStepKeys.businessTypeConfirmationAi]: {
    categoryId,
  },
  [AssessmentStepKeys.approxRevenue]: {
    helperText: messages.helperText,
  },
})

export const CyberConditionalOffer = () => (
  <ConditionalOfferAssessment
    categoryId={categoryId}
    makeStepProps={makeStepProps}
    stepKeys={cyberAssessmentSteps}
    transformSubmitValues={makeSubmitValues()}
  />
)
